import React from 'react';
import { Control, Controller } from 'react-hook-form';

import { RoleGuard } from '@/features/RoleGuard/RoleGuard';
import { UserRole } from '@/types/user';

import { UserSelector } from '../UserSelector';
import { FormFields, FormValues } from '../../types';

import s from './UsersSection.module.scss';

type UsersSectionProps = {
  control: Control<FormValues>;
  showCompanion: boolean;
  onToggleCompanion: () => void;
};

export const UsersSection: React.FC<UsersSectionProps> = ({
  control,
  showCompanion,
  onToggleCompanion,
}) => {
  return (
    <RoleGuard roles={[UserRole.admin]}>
      <div className={s.section}>
        <div className={s.header}>
          <p>Пользователь(и)</p>
          <button type="button" className={s.logs_toggle} onClick={onToggleCompanion}>
            {showCompanion ? 'Скрыть логи' : 'Показать логи'}
          </button>
        </div>
        <Controller
          control={control}
          name={FormFields.users}
          render={({ field }) => (
            <UserSelector value={field.value || []} onChange={field.onChange} />
          )}
        />
      </div>
    </RoleGuard>
  );
};
